import {
  createFileRoute,
  Link,
  Outlet,
  useCanGoBack,
  useRouter,
} from '@tanstack/react-router';
import { CircleArrowLeft } from 'lucide-react';

import { useGetClass } from '~entities/classes/api/get-class';

import { Button } from '~shared/shadcn/ui/button';

const Component = () => {
  const router = useRouter();
  const canGoBack = useCanGoBack();

  const { classId } = Route.useParams();

  const { data } = useGetClass({ classId });

  return (
    <div className=''>
      <>
        <div className='mb-8 flex items-center gap-2'>
          {canGoBack ? (
            <Button
              variant={'ghost'}
              className='flex items-center p-2 [&_svg]:size-6'
              disabled={!canGoBack}
              onClick={() => {
                router.history.back();
              }}
            >
              <CircleArrowLeft className='size-6' />
            </Button>
          ) : (
            <Link to='/attendance' className='flex items-center gap-2'>
              <CircleArrowLeft className='size-6 text-custom-secondary-1' />
              <h2 className='text-2xl font-semibold text-custom-secondary-1'>
                {data?.title}
              </h2>
            </Link>
          )}
          <h2 className='text-2xl font-semibold'> {data?.title}</h2>
        </div>
        <div className='border-t'>
          <Outlet />
        </div>
      </>
    </div>
  );
};

export const Route = createFileRoute('/_auth/_layout/attendance/$classId')({
  component: Component,
});
